import apiFarms from "../config/api_farms";
import getHeaders from "./getHeaders";

export function findFeedFactoryParameterData(payload) {
  const { groupId, farmId, signal } = payload;
  return apiFarms.get(
    `/bovexo/${groupId}/farms/${farmId}/feed/factory/parameters`,
    getHeaders(false, signal),
  );
}

export function saveFeedFactoryParameterData(payload) {
  const { groupId, farmId, body, signal } = payload;
  return apiFarms.post(
    `/bovexo/${groupId}/farms/${farmId}/feed/factory/parameters`,
    body,
    getHeaders(false, signal),
  );
}
